exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".financial-setup .setup-item[data-v-7ae06257]{margin:10px}.financial-setup .setup-item .setup-item-header[data-v-7ae06257]{font-weight:bold;margin-top:10px}.financial-setup .setup-item .setup-item-tip[data-v-7ae06257]{display:inline-block;color:#999;font-size:14px;margin-bottom:20px}\n", ""]);

// exports
